import Papa from "papaparse";
import React, { useEffect, useRef, useState } from "react";
import { adminReqConfig, api } from "../../include/api";
import "../../styles/Super.css";
import AdminHeader from "./Header";
import { ChevronDown,X } from "react-feather";
import { useNotification } from "../../Toast/ToastProvider";
import {
  CustomColoredDropdown,
  CustomDropdown,
  FilterPanel,
  formatInvoiceId,
  formatShortMonthDateYearWithTime,
  formatTransactionId,
  getAdmin,
  PAYMENT_OPTIONS,
} from "../../include/function";
import { useNavigate, useSearchParams } from "react-router-dom";

const ListPayment = ({ from }) => {
  const [fetchLoading, setFetchLoading] = useState(true);
  const [orderData, setOrderData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const toast = useNotification();
  const [selectedData, setSelectedData] = useState([]);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const navigate = useNavigate();
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const user = getAdmin();
  const [searchParams] = useSearchParams();
  const initialQuery = searchParams.get("q") || "";
  const [searchQuery, setSearchQuery] = useState(initialQuery);

  useEffect(() => {
    const q = searchParams.get("q") || "";
    setSearchQuery(q);
  }, [searchParams]);
  
  const [productPermissions, setProductPermissions] = useState({
    add: false,
    view: false,
    edit: false,
    delete: false,
  });
  useEffect(() => {
    const fetchPermissions = async () => {
      if (!user?.roleId) return;

      try {
        const res = await api.get(
          `/role_permission/?roleId=${user.roleId}`,
          adminReqConfig(),
        );
        if (res.status === 200 && Array.isArray(res.data.data)) {
          // Find permission entry where pageTitle === "Product"
          const productPerm = res.data.data.find(
            (p) => p.pageTitle === "Sales Invoices",
          );

          if (productPerm) {
            setProductPermissions({
              add: productPerm.add === "true" || productPerm.add === 1,
              view: productPerm.view === "true" || productPerm.view === 1,
              edit: productPerm.edit === "true" || productPerm.edit === 1,
              delete: productPerm.delete === "true" || productPerm.delete === 1,
            });
          }
        }
      } catch (err) {
        console.warn("Failed to fetch product permissions", err);
      }
    };

    fetchPermissions();
  }, [user?.roleId]);
  //Filter values (all optional)
  const [filterValues, setFilterValues] = useState({
    date: "",
    status: "",
    paymentType: "",
    customerType: "",
    timePeriod: "",
    fromDate: "",
    toDate: "",
  });

  //Fetch filter options on mount
  useEffect(() => {
    // Brands
    api
      .get("/brand/", adminReqConfig())
      .then((res) => setBrands(res.data.data || []))
      .catch(() => setBrands([]));

    // Main categories (parent_id = 0)
    api
      .get("/category/?flag=exceptHome", adminReqConfig())
      .then((res) => setCategories(res.data.data || []))
      .catch(() => setCategories([]));

    // Products (limit to avoid overload)
    api
      .get("/product/?limit=200", adminReqConfig())
      .then((res) => setProducts(res.data.data || []))
      .catch(() => setProducts([]));
  }, []);

  //Fetch orders with filters
  const getOrder = (filters = {}) => {
    setFetchLoading(true);
    const params = new URLSearchParams();
    if (filters.date) params.set("date", filters.date);
    if (filters.fromDate) params.set("fromDate", filters.fromDate);
    if (filters.toDate) params.set("toDate", filters.toDate);
    if (filters.status) params.set("status", filters.status);
    if (filters.paymentType) params.set("paymentType", filters.paymentType);
    if (filters.paymentStatus)
      params.set("paymentStatus", filters.paymentStatus);
    if (filters.customerType) params.set("customerType", filters.customerType);

    let url = "/super_sales_invoice/";
    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    api
      .get(url, adminReqConfig())
      .then((response) => {
        if (response.status === 200 && Array.isArray(response.data.data)) {
          // Sort by date in descending order (newest first)
          const sortedData = response.data.data.sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            return dateB - dateA; // Descending order
          });

          const normalizedData = sortedData.map((order) => ({
            ...order,
            orderItems: (order.orderItems || []).map((item) => ({
              ...item,
              paymentStatus: item.paymentStatus?.toLowerCase(),
              status: item.status?.toLowerCase(),
            })),
          }));

          //  filter the data form orderItmes status
          const filteredOrders = normalizedData.filter((order) => {
            if (!order.orderItems || order.orderItems.length === 0) {
              return true;
            }
            return (
              order?.orderItems?.[0]?.status !== "rejected" &&
              order?.orderItems?.[0].status !== "need-approval"
            );
          });

          setOrderData(filteredOrders);
          setFilteredData(filteredOrders);
        } else {
          setOrderData([]);
          setFilteredData([]);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch invoice:", error);
        setOrderData([]);
        setFilteredData([]);
      })
      .finally(() => setFetchLoading(false));
  };

  //Initial load
  useEffect(() => {
    getOrder();
  }, []);

  //Search
  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredData(orderData);
      return;
    }

    const query = searchQuery.toLowerCase().trim();

    const filtered = orderData.filter((order) => {
      // Helper: Format invoice ID for comparison
      const getFormattedInvoiceId = (ord) => {
        if (!ord?.createTimestamp || !ord?.id) return "INV--";
        const year = new Date(ord.createTimestamp).getFullYear();
        const yy = String(year).slice(-2);
        const paddedId = String(ord.id).padStart(4, "0");
        return `INV${yy}-${paddedId}`;
      };

      const invoiceId = getFormattedInvoiceId(order);

      return (
        order.id?.toString().startsWith(query) ||
        invoiceId.toLowerCase().startsWith(query) ||
        order.name?.toLowerCase().startsWith(query) ||
        order.customerName?.toLowerCase().startsWith(query) ||
        order.customerType?.toLowerCase().startsWith(query) ||
        order.orderItems?.some(
          (item) =>
            item.productName?.toLowerCase().startsWith(query) ||
            item.variant?.toLowerCase().startsWith(query),
        )
      );
    });

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [searchQuery, orderData, searchParams]);

  //Pagination logic
  let currentItems = [];
  let totalPage = 1;
  let showingFrom = 0;
  let showingTo = 0;
  if (itemsPerPage === "all") {
    currentItems = filteredData;
    showingFrom = filteredData.length > 0 ? 1 : 0;
    showingTo = filteredData.length;
  } else {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    totalPage = Math.ceil(filteredData.length / itemsPerPage);
    showingFrom = indexOfFirstItem + 1;
    showingTo = Math.min(indexOfLastItem, filteredData.length);
  }

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  //Close filter panel on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isFilterPanelOpen && !e.target.closest(".nav-item")) {
        setIsFilterPanelOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isFilterPanelOpen]);

  const handleDownloadCSV = (exportScope = "current") => {
    let dataToExport = [];

    // ✅ PRIORITY 1: If items selected → ALWAYS export selected (overrides everything)
    if (selectedData.length > 0) {
      dataToExport = orderData.filter((order) =>
        selectedData.includes(order.id),
      );
    }
    // ✅ PRIORITY 2: If "Export All" clicked → export entire dataset
    else if (exportScope === "all") {
      dataToExport = orderData;
    }
    // ✅ PRIORITY 3: Default → export current page items only
    else {
      dataToExport = currentItems;
    }

    if (dataToExport.length === 0) {
      toast({ type: "error", message: "No order data to download" });
      return;
    }

    const csvRows = [];
    let serialNo = 1;

    dataToExport.forEach((order) => {
      const baseOrderInfo = {
        "S.No": serialNo,
        "Order ID": order.id || "-",
        "Customer Name": order.name || "-",
        Phone: order.phoneNumber || "-",
        "Order Date": order.date
          ? new Date(order.date).toLocaleString("en-IN")
          : "-",
        "Delivery Address": order.address || "-",
        "Delivery City": order.city || "-",
        "Delivery State": order.state || "-",
        "Total Amount": order.totalAmount || 0,
        "Payment Mode": order.orderItems?.[0]?.paymentMode || "-",
        "Payment Status": order.orderItems?.[0]?.paymentStatus || "-",
        "Payment Info": order.orderItems?.[0]?.paymentInfo || "-",
      };

      if (!order.orderItems || order.orderItems.length === 0) {
        csvRows.push({
          ...baseOrderInfo,
          "Item ID": "",
          "Product ID": "",
          "Product Name": "",
          Qty: "",
          "Price per Unit": "",
          "Item Amount": "",
          "Discount Mode": "",
          "Discount Value": "",
          "Discount Label": "",
          "Main Image URL": "",
          "Item Status": "",
          "Shop ID": "",
        });
        serialNo++;
      } else {
        order.orderItems.forEach((item) => {
          csvRows.push({
            ...baseOrderInfo,
            "S.No": serialNo++,
            "Item ID": item.id || "-",
            "Product ID": item.productId || "-",
            "Product Name": item.productName || "-",
            Qty: item.qty || 0,
            "Price per Unit": item.price || 0,
            "Item Amount": item.amount || 0,
            "Discount Mode": item.discountMode || "-",
            "Discount Value": item.discountValue || 0,
            "Discount Label": item.discountLabel || "-",
            "Main Image URL": item.mainImage || "-",
            "Item Status": item.status || "-",
            "Shop ID": item.shopId || "-",
          });
        });
      }
    });

    const columns = [
      "S.No",
      "Order ID",
      "Customer Name",
      "Phone",
      "Delivery Address",
      "Delivery City",
      "Delivery State",
      "Total Amount",
      "Payment Mode",
      "Payment Status",
      "Payment Info",
      "Item ID",
      "Product ID",
      "Product Name",
      "Qty",
      "Price per Unit",
      "Item Amount",
      "Discount Mode",
      "Discount Value",
      "Discount Label",
      "Main Image URL",
      "Item Status",
      "Shop ID",
    ];

    // ✅ CRITICAL FIX: Proper object syntax with "data:" key (copy this exactly)
    const csv = Papa.unparse({
      fields: columns,
      data: csvRows.map(function (row) {
        return columns.map(function (col) {
          return row[col];
        });
      }),
    });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    // ✅ Dynamic filename based on export type
    const fileName =
      selectedData.length > 0
        ? `Payment_Selected_${selectedData.length}.csv`
        : exportScope === "all"
          ? "Payment_All.csv"
          : `Payment_Page${currentPage}.csv`;

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  //Row expand/collapse
  const toggleExpand = (orderId) => {
    setExpandedRows((prev) =>
      prev.includes(orderId)
        ? prev.filter((id) => id !== orderId)
        : [...prev, orderId],
    );
  };
  const handlePaymentDetailClick = (orderId) => {
    navigate(`/admin/sales/payment/${orderId}`);
  };
  //Selection handlers
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = currentItems.map((p) => p.id);
      setSelectedData((prev) => [...new Set([...prev, ...allIds])]);
    } else {
      const idsToRemove = currentItems.map((p) => p.id);
      setSelectedData((prev) => prev.filter((id) => !idsToRemove.includes(id)));
    }
  };
  const handleSelectOne = (id) => {
    setSelectedData((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id],
    );
  };

  //Apply & Clear filters
  const applyFilters = () => {
    let finalFilters = { ...filterValues };

    // Handle timePeriod presets
    if (filterValues.timePeriod && filterValues.timePeriod !== "period") {
      const now = new Date();
      let fromDate = "";
      let toDate = "";

      switch (filterValues.timePeriod) {
        case "today":
          fromDate = toDate = now.toISOString().split("T")[0];
          break;
        case "yesterday":
          const yesterday = new Date(now);
          yesterday.setDate(now.getDate() - 1);
          fromDate = toDate = yesterday.toISOString().split("T")[0];
          break;
        case "thisMonth":
          fromDate = `${now.getFullYear()}-${String(
            now.getMonth() + 1,
          ).padStart(2, "0")}-01`;
          toDate = now.toISOString().split("T")[0];
          break;
        case "last3Months":
          const threeMonthsAgo = new Date(now);
          threeMonthsAgo.setMonth(now.getMonth() - 3);
          fromDate = threeMonthsAgo.toISOString().split("T")[0];
          toDate = now.toISOString().split("T")[0];
          break;
        case "thisYear":
          fromDate = `${now.getFullYear()}-01-01`;
          toDate = `${now.getFullYear()}-12-31`;
          break;
        case "all":
        default:
          fromDate = toDate = "";
      }

      finalFilters = {
        ...finalFilters,
        fromDate,
        toDate,
      };
    }

    // Clear the old `date` filter if using range
    if (finalFilters.timePeriod) {
      finalFilters.date = ""; // because backend uses either `date` OR `fromDate/toDate`
    }

    getOrder(finalFilters);
    setIsFilterPanelOpen(false);
  };

  const clearFilters = () => {
    const empty = {
      date: "",
      status: "",
      paymentType: "",
      customerType: "",
    };
    setFilterValues(empty);
    getOrder(empty);
    setIsFilterPanelOpen(false);
  };

  const calculateCreditDays = (creditDateStr, creditLimitStr) => {
    // Parse credit limit safely
    const creditLimit = parseInt(creditLimitStr, 10);
    if (isNaN(creditLimit) || creditLimit < 0) {
      return { daysRemaining: NaN, creditLimit: NaN };
    }

    // Parse credit start date
    const startDate = new Date(creditDateStr);
    if (isNaN(startDate.getTime())) {
      return { daysRemaining: NaN, creditLimit };
    }

    const now = new Date();
    // Normalize to midnight for day-only comparison
    const startDay = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate(),
    );
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const diffTime = today - startDay; // milliseconds
    const daysPassed = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    const daysRemaining = Math.max(0, creditLimit - daysPassed);

    return { daysRemaining, creditLimit };
  };

  return (
    <>
      <AdminHeader title={"PAYMENT LIST"}>
        <div className="content-wrapper p-0">
          <section
            style={{
              backgroundColor: "#F1F4F9",
              padding: "30px",
              marginTop: "70px",
              marginBottom: "40px",
              minHeight: "80vh",
            }}
          >
            {fetchLoading ? (
              <p>Loading orders...</p>
            ) : (
              <>
                <div className="rounded-5 bg-white py-24">
                  <div className="row align-items-center px-24 py-10 mb-3">
                    <div className="col-auto">
                      <h6 className="mb-0">All Payment List</h6>
                    </div>
                    <div className="col d-flex align-items-center">
                      <div
                        className="nav-item"
                        style={{ position: "relative" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #c6d6f5",
                            borderRadius: "8px",
                            backgroundColor: "#fff",
                            width: "500px",
                          }}
                        >
                          <img
                            src="/assets/images/search-icon.png"
                            style={{ width: "18px", marginLeft: "8px" }}
                          />
                          <input
                            type="text"
                            placeholder="Filter and search here..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onFocus={() => setIsFilterPanelOpen(true)}
                            style={{
                              border: "none",
                              outline: "none",
                              padding: "8px 8px",
                              width: "100%",
                              fontSize: "14px",
                              color: "#333",
                              backgroundColor: "transparent",
                            }}
                            />
                             {searchQuery && (
                                                      <X
                                                        size={24}
                                                        onClick={(e) => {
                                                          e.stopPropagation(); 
                                                          setSearchQuery(""); 
                                                          setCurrentPage(1);
                                                          setIsFilterPanelOpen(false);
                                                        }}
                                                        style={{
                                                          position: "absolute",
                                                          right: "40px", 
                                                          cursor: "pointer",
                                                          color: "#999",
                                                          padding: "4px",
                                                          zIndex: 10,
                                                        }}
                                                        onMouseEnter={(e) =>
                                                          (e.currentTarget.style.color = "#666")
                                                        }
                                                        onMouseLeave={(e) =>
                                                          (e.currentTarget.style.color = "#999")
                                                        }
                                                      />
                                                    )}  
                          <ChevronDown
                            size={16}
                            style={{
                              marginRight: "8px",
                              color: "#999",
                              cursor: "pointer",
                              transform: isFilterPanelOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              transition: "transform 0.2s",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsFilterPanelOpen(!isFilterPanelOpen);
                            }}
                          />
                        </div>
                        {isFilterPanelOpen && (
                          <FilterPanel
                            filterValues={filterValues}
                            onFilterChange={(key, value) =>
                              setFilterValues((prev) => ({
                                ...prev,
                                [key]: value,
                              }))
                            }
                            onApply={applyFilters}
                            onClear={clearFilters}
                            filterConfig={{
                              showCustomerType: true,
                              showTimePeriod: true,
                              showPaymentType: true,
                              showPaymentStatus: true,
                              showStatus: false,
                              showCategory: false,
                              showBrand: false,
                              showProduct: false,
                            }}
                          />
                        )}
                      </div>
                    </div>
                    <div className="d-flex col-auto">
                      <CustomDropdown handleDownloadCSV={handleDownloadCSV} />
                    </div>
                  </div>

                  {/* Table */}
                  <div className="table-responsive mt-24 product-table">
                    <table className="table table-striped custom-striped-table-product-list align-middle">
                      <thead>
                        <tr>
                          <th scope="col">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              style={{ borderColor: "#c5d5f5" }}
                              onChange={handleSelectAll}
                              checked={
                                currentItems.length > 0 &&
                                currentItems.every((p) =>
                                  selectedData.includes(p.id),
                                )
                              }
                            />
                          </th>

                          <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Invoice ID
                          </th>
                          {/* <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Product Name
                          </th> */}
                          <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Customer Name
                          </th>
                          <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Billing Name
                          </th>
                          <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Customer Type
                          </th>
                          <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Total Amount
                          </th>
                          <th
                            scope="col"
                            style={{
                              fontSize: "15px",
                              textWrap: "nowrap",
                              // width: "120px",
                            }}
                          >
                            Payment Date & Time
                          </th>
                          <th
                            scope="col"
                            style={{
                              fontSize: "15px",
                              textWrap: "nowrap",
                            }}
                          >
                            Payment Type
                          </th>
                          <th
                            scope="col"
                            style={{
                              fontSize: "15px",
                              textWrap: "nowrap",
                              // width: "120px",
                            }}
                          >
                            Credit Balance
                          </th>
                          <th
                            scope="col"
                            style={{
                              fontSize: "15px",
                              textWrap: "nowrap",
                              // width: "120px",
                            }}
                          >
                            Credit Limit (In Days)
                          </th>

                          <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Payment Status
                          </th>
                          <th
                            scope="col"
                            style={{ fontSize: "15px", textWrap: "nowrap" }}
                          >
                            Billing Address
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length > 0 ? (
                          currentItems.map((order) => {
                            const isMulti =
                              order?.payment?.length > 0 ? true : "";
                            const isExpanded = expandedRows.includes(order.id);
                            const { daysRemaining, creditLimit } =
                              calculateCreditDays(
                                order.creditDate,
                                order.creditLimit,
                              );

                            // Safely validate the result
                            const isValidCreditData =
                              typeof daysRemaining === "number" &&
                              typeof creditLimit === "number" &&
                              !isNaN(daysRemaining) &&
                              !isNaN(creditLimit) &&
                              creditLimit >= 0;

                            const creditDaysDisplay = isValidCreditData
                              ? `${String(daysRemaining).padStart(
                                  2,
                                  "0",
                                )}/${String(creditLimit).padStart(2, "0")}`
                              : "N/A";
                            // const isCredit = order?.orderItems[0]?.paymentMode.toLowerCase() === 'credit';
                            const currentCredit =
                              Number(order?.currentCredit) || 0;
                            const creditBal = Number(order?.creditBal) || 0;

                            const isOverdue = currentCredit > creditBal;
                            return (
                              <React.Fragment key={order.id}>
                                <tr
                                  className={
                                    isOverdue ? "overdue-row" : undefined
                                  }
                                >
                                  <td>
                                    <input
                                      type="checkbox"
                                      style={{ borderColor: "#c5d5f5" }}
                                      className="form-check-input"
                                      checked={selectedData.includes(order.id)}
                                      onChange={() => handleSelectOne(order.id)}
                                    />
                                  </td>

                                  <td>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        textWrap: "nowrap",
                                      }}
                                    >
                                      {order?.payment?.length > 0 ? (
                                        <button
                                          style={{
                                            border: "2px solid #006fbf",
                                            color: "#006fbf",
                                            background: "transparent",
                                            borderRadius: "4px",
                                            width: "14px",
                                            height: "14px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontSize: "12px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => toggleExpand(order.id)}
                                        >
                                          {isExpanded ? "−" : "+"}
                                        </button>
                                      ) : (
                                        ""
                                      )}
                                      <span
                                        className={
                                          isOverdue
                                            ? "over-due-color"
                                            : undefined
                                        }
                                      >
                                        {formatInvoiceId(order)}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      onClick={() =>
                                        handlePaymentDetailClick(order.id)
                                      }
                                      style={{
                                        background: "none",
                                        border: "none",
                                        // color: "#006fbf",
                                        // textDecoration: "underline",
                                        cursor: "pointer",
                                        padding: 0,
                                      }}
                                      title="View Payment Details"
                                    >
                                      <span
                                        className={
                                          isOverdue
                                            ? "over-due-color"
                                            : "text - primary"
                                        }
                                      >
                                        {order.customerName}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        isOverdue ? "over-due-color" : undefined
                                      }
                                    >
                                      {order.name}{" "}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        isOverdue ? "over-due-color" : undefined
                                      }
                                    >
                                      {order.customerType
                                        ? `${order.customerType} (${
                                            order.customerType === "individual"
                                              ? "B2C"
                                              : "B2B"
                                          })`
                                        : "N/A"}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        isOverdue ? "over-due-color" : undefined
                                      }
                                    >
                                      ₹
                                      {Math.round(
                                        order.totalAmount,
                                      ).toLocaleString()}
                                    </span>
                                  </td>

                                  <td>
                                    <span
                                      className={
                                        isOverdue ? "over-due-color" : undefined
                                      }
                                    >
                                      {formatShortMonthDateYearWithTime(
                                        order.createTimestamp,
                                      )}
                                    </span>
                                  </td>

                                  <td>
                                    <span
                                      className={
                                        isOverdue ? "over-due-color" : undefined
                                      }
                                    >
                                      {order?.orderItems[0]?.paymentMode}
                                    </span>
                                  </td>

                                  <td>
                                    <span
                                      className={
                                        isOverdue ? "over-due-color" : undefined
                                      }
                                    >
                                      {order?.currentCredit != null &&
                                      order?.orderItems[0]?.paymentMode.toLowerCase() ===
                                        "credit" &&
                                      order?.creditBal != null
                                        ? order.creditBal - order.currentCredit
                                        : "N/A"}{" "}
                                    </span>
                                  </td>

                                  <td>
                                    <span
                                      className={
                                        isOverdue ? "over-due-color" : undefined
                                      }
                                    >
                                      {order?.orderItems[0]?.paymentMode ===
                                      "credit"
                                        ? creditDaysDisplay
                                        : "N/A"}
                                    </span>
                                  </td>
                                  <td>
                                    <CustomColoredDropdown
                                      value={order.paymentStatus}
                                      options={PAYMENT_OPTIONS}
                                      type="payment"
                                      disable={true}
                                    />
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        isOverdue
                                          ? "over-due-color"
                                          : "undefined"
                                      }
                                    >
                                      {order.address}, {order.locality},{" "}
                                      {order.city},{order.state}
                                    </span>
                                  </td>
                                </tr>
                                {isExpanded &&
                                  order.payment.map((item, idx) => (
                                    <tr key={item.id} className="bg-light">
                                      <td></td>
                                      <td style={{ paddingLeft: "30px" }}>
                                        {idx + 1}.
                                      </td>
                                      <td>
                                        {formatTransactionId(order, item)}
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td>
                                        ₹
                                        {Math.round(
                                          item.amount,
                                        ).toLocaleString()}
                                      </td>
                                      <td>
                                        {formatShortMonthDateYearWithTime(
                                          item.createdTimestamp,
                                        )}
                                      </td>
                                      <td>{item.paymentMode}</td>
                                      <td></td>
                                    </tr>
                                  ))}
                              </React.Fragment>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="11" className="text-center py-3">
                              No Payment found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <div className="d-flex justify-content-between align-items-center mt-16 p-16">
                    <div className="d-flex align-items-center">
                      <select
                        className="form-select d-inline-block w-auto"
                        value={itemsPerPage}
                        onChange={(e) => {
                          const val = e.target.value;
                          setItemsPerPage(
                            val === "all" ? "all" : parseInt(val),
                          );
                          setCurrentPage(1);
                        }}
                        style={{
                          height: "34px",
                          fontSize: "14px",
                          minWidth: "70px",
                        }}
                      >
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="all">All</option>
                      </select>
                      <span className="ms-2">
                        Showing {showingFrom} to {showingTo} of{" "}
                        {filteredData.length} Lists
                      </span>
                    </div>
                    <nav>
                      <ul className="pagination mt-0">
                        <li
                          className={`page-item ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => paginate(currentPage - 1)}
                          >
                            &laquo;
                          </button>
                        </li>
                        {(() => {
                          const pagesToShow = 5;
                          let startPage = Math.max(
                            1,
                            currentPage - Math.floor(pagesToShow / 2),
                          );
                          let endPage = startPage + pagesToShow - 1;

                          if (endPage > totalPage) {
                            endPage = totalPage;
                            startPage = Math.max(1, endPage - pagesToShow + 1);
                          }

                          const pageNumbers = [];
                          for (let i = startPage; i <= endPage; i++) {
                            pageNumbers.push(i);
                          }

                          return pageNumbers.map((pageNum) => (
                            <li
                              key={pageNum}
                              className={`page-item ${
                                currentPage === pageNum ? "active" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => paginate(pageNum)}
                              >
                                {pageNum}
                              </button>
                            </li>
                          ));
                        })()}
                        <li
                          className={`page-item ${
                            currentPage === totalPage ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => paginate(currentPage + 1)}
                          >
                            &raquo;
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </>
            )}
          </section>
        </div>
      </AdminHeader>
    </>
  );
};;

export default ListPayment;
